<template>
  <div class="record-container">
    <div v-if="itemIndex === 0" class="shop-view">
      <img class="shop-icon" src="../../../static/img/shopping_cart/icon_wdpj_dp.png">
      <span class="shop-title">{{ record.busi_name }}</span>
    </div>
    <div class="meal-view">
      <img :src="record.photo" class="meal-icon" @error="errorLoadImg()">
      <span class="detail-view">
        <div class="meal-name">{{ titleText }}</div>
        <div class="price-view">
          <span class="price">¥{{ record.dis_price ? record.dis_price : record.actual_price }}</span>
          <span class="meal-count-view">
            <span class="minus" @click="changeMealCount(-1)">
              <img class="minus-icon" src="../../../static/img/shopping_cart/minus.png">
            </span>
            <span class="count">{{ record.meal_count }}</span>
            <span class="add" @click="changeMealCount(1)">
              <img class="add-icon" src="../../../static/img/shopping_cart/add.png">
            </span>
          </span>
        </div>
      </span>
    </div>
    <div class="break-line"/>
    <label v-if="totalLength === itemIndex" class="remarks-view">
      <img src="../../../static/img/shopping_cart/icon_bz.png" class="remarks-icon">
      <span class="remarks-title">备注</span>
      <input v-model="remarks" class="remarks-text">
    </label>
    <div v-if="totalLength === itemIndex" class="break-block"/>
  </div>
</template>

<script>
export default {
  name: 'RecordItem',
  props: {
    record: {
      type: Object,
      default: {}
    },
    itemIndex: {
      type: Number,
      default: -1
    },
    arrIndex: {
      type: Number,
      default: -1
    },
    totalLength: {
      type: Number,
      default: 0
    },
  },
  computed: {
    titleText () {
      return this.record.menu_name.length > 12 ? this.record.menu_name.slice(0, 12) + '...' : this.record.menu_name
    }
  },
  updated () {
    let props = {
      remarks: this.remarks,
      itemIndex: this.arrIndex
    }
    // 设置备注信息
    this.$store.commit('set_remarks_data', props)
  },
  data () {
    return {
      remarks: ''
    }
  },
  methods: {
    /**
     * 修改商品数量
     */
    changeMealCount (key) {
      let params = {
        arrIndex: this.arrIndex,
        itemIndex: this.itemIndex,
        mealCount: this.record.meal_count + key
      }
      this.$store.commit('modify_shopping_cart_data', params)
    },
    /**
     * 如果图片加载出错，显示默认图片
     */
    errorLoadImg () {
      const eventTag = event.toElement || event.target;
      eventTag.src = "../../../static/img/shopping_cart/pic_home_default.png"
    }
  }
}
</script>

<style lang="less" scoped>
.record-container {
  width: 280px;
  .shop-view {
    width: 300px;
    height: 40px;
    display: flex;
    align-items: center;
    margin-top: 15px;
    background-color: #f5f5f5;
    margin-left: -10px;
    .shop-icon {
      width: 16px;
      height: 16px;
      margin-left: 10px;
    }
    .shop-title {
      margin-left: 10px;
      font-size: 18px;
      color: #333333;
    }
  }
  .meal-view {
    width: 100%;
    height: 60px;
    display: flex;
    flex-direction: row;
    margin-top: 15px;
    .meal-icon {
      width: 60px;
      height: 100%;
      border-radius: 4px;
    }
    .detail-view {
      width: 210px;
      height: 100%;
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      margin-left: 8px;
      .meal-name {
        font-size: 16px;
        color: #333333;
      }
      .price-view {
        display: flex;
        justify-content: space-between;
        .price {
          font-size: 18px;
          color: #ff4c4c;
        }
        .meal-count-view {
          display: flex;
          justify-content: flex-end;
          height: 24px;
          text-align: center;
          cursor: pointer;
          .minus {
            border-radius: 4px 0px 0px 4px;
	          border: solid 1px #e0e0e0;
            .minus-icon {
              width: 12px;
              height: 12px;
            }
          }
          .count {
            width: 36px;
            display: inline-block;
            border-left: 0;
            border-right: 0;
            color: #333333;
            font-size: 16px;
            border: solid 1px #e0e0e0;   
          }
          .add {
            border-radius: 0px 4px 4px 0px;
	          border: solid 1px #e0e0e0;
            .add-icon {
              width: 12px;
              height: 12px;
            }
          }
          .minus, .add {
            width: 30px;
            display: inline-block;
            color: #999999;
          }
        }
      }
    }
  }
  .break-line {
    border-bottom: 1px solid #e0e0e0;
    margin-top: 15px;
  }
  .break-block {
    width: 300px;
    height: 6px;
    margin-top: 8px;
    margin-left: -10px;
    background-color: #fafafa;
  }
  .remarks-view {
    width: 100%;
    height: 30px;
    display: flex;
    align-items: center;
    margin-top: 8px;
    cursor: pointer;
    .remarks-icon {
      width: 20px;
      height: 20px;
    }
    .remarks-title {
      font-size: 16px;
      margin-left: 5px;
      color: #999999;
    }
    .remarks-text {
      margin-left: 10px;
      font-size: 16px;
      color: #333333;
      outline: none;
      border: 0;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/shopping_cart/record_item.vue